import { Grid } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { FormikProps } from 'formik';
import LabeledInput from '../Common/LabeledInput';
import CustomPhoneNumberInput from '../CustomPhoneNumberInput/CustomPhoneNumberInput';
import { FormValues } from '../../utils/validations/clientDetailsForm';

export interface SingleClientDetailFormProps {
  formik: FormikProps<FormValues>;
}
function SingleClientDetailForm({ formik }: SingleClientDetailFormProps) {
  const { t } = useTranslation();
  return (
    <>
      {/* third row */}
      <Grid item display="flex" gap="12px">
        <Grid item xs={6}>
          <LabeledInput
            label={`${t('addNewClient.name')}/${t('addNewClient.nickName')}`}
            id="first-name"
            type="text"
            name="firstName"
            value={formik.values.firstName}
            onBlur={formik.handleBlur}
            placeholder={t('addNewClient.firstName')}
            disabled
          />
        </Grid>
        <Grid item xs={6}>
          <LabeledInput
            id="dob"
            type="text"
            name="dob"
            label={t('addNewClient.birthday')}
            value={
              formik.values.dob
                ? formik.values.dob.toString().split('T')[0].split('-').join(' / ')
                : ''
            }
            disabled
          />
        </Grid>
      </Grid>
      {/* email */}
      <Grid item display="flex" gap="12px">
        <Grid item xs={6}>
          <LabeledInput
            label={`${t('addNewClient.email')}`}
            id="email"
            type="email"
            value={formik.values.email}
            onBlur={formik.handleBlur}
            placeholder={t('addNewClient.email')}
            disabled
          />
        </Grid>
        <Grid item xs={6}>
          <CustomPhoneNumberInput
            value={formik.values.phoneNumber}
            onBlur={formik.handleBlur}
            disabled
          />
        </Grid>
      </Grid>
    </>
  );
}
export default SingleClientDetailForm;
